/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import { withRouter } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import NativeSelect from '@material-ui/core/NativeSelect';
import InputLabel from '@material-ui/core/InputLabel';
import Button from '@material-ui/core/Button';
import Caret from '@material-ui/icons/ArrowForwardIos';
import {
    object, shape, array, string,
} from 'prop-types';

const styles = (theme) => ({
    t: {
        color: theme.something,
    },
    giftFinderGFB: {
        boxSizing: 'border-box',
        padding: '45px 20px',
        margin: '30px auto',
        maxWidth: '980px',
        width: '90%',
        textAlign: 'center',
        height: 'auto',
        background: theme.palette.cms?.skuLabelTransitionColor,
        '@media screen and (max-width: 601px)': {
            padding: '15px 5px 25px',
            margin: '10px auto 20px auto',
        },
        '& h2': {
            margin: '0 auto',
            fontSize: '2em',
            lineHeight: '2em',
            '@media screen and (max-width: 601px)': {
                fontSize: '1.8em',
            },
        },
    },

    container: {
        width: '100%',
        maxWidth: '860px',
        margin: '0 auto',
    },
    fieldBlock: {
        '& label': {
            top: '10%',
        },
        '& [class*="shrink"]': {
            top: '8px',
        },
        '& .MuiInput-select:focused': {
            background: theme.palette.myAccount?.container?.backgroundColor,
        },
    },
    select: {
        width: '250px',
        '@media screen and (max-width: 601px)': {
            width: '300px',
            maxWidth: '100%',
        },
        border: `solid 1px ${theme.palette.sympathyPage?.borderColors}`,
        paddingLeft: '14px',
        borderRadius: 2,
        background: theme.palette.tiers?.card?.backgroundColor,
        fontSize: '1.2em',
        '& :focus': {
            borderRadius: 3,
            background: theme.palette.myAccount?.container?.backgroundColor,
        },
    },
    iconStyle: {
        width: '.55em',
        height: '.55em',
        margin: '-.05em 0 0 .2em',
    },
    button: {
        margin: '20px auto 0',
        borderRadius: '2px',
        background: theme.palette.text?.primary,
        '@media screen and (max-width: 601px)': {
            width: '300px',
            maxWidth: '100%',
        },
    },
    heading: {
        margin: '0 auto 20px',
        padding: '0 10% 15px',
        '@media screen and (max-width: 601px)': {
            padding: '0 5px 15px',
        },
        '@media screen and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
            width: '50%', // IE
        },
        width: 'fit-content',
        borderBottom: 'solid 1px #888',
        display: 'flex',
        alignItems: 'center',
    },
    headingCopy: {
        fontSize: '2em',
        '@media screen and (max-width: 601px)': {
            fontSize: '1.8em',
        },
    },
    headingImg: {
        position: 'relative',
        display: 'inline-block',
        width: '70px',
        height: '70px',
        margin: '0 20px 0 0',
        '& img': {
            width: '70px',
            height: '70px',
        },
        '@media screen and (max-width: 601px)': {
            width: '30px',
            height: '30px',
            margin: '0 10px 0 0',
            '& img': {
                width: '30px',
                height: '30px',
            },
        },
    },
});

function GraphqlFoodGiftFinder(props) {
    const { data, history, classes } = props;
    const [state, setState] = React.useState({
        occasion: '',
        recipient: '',
        price: '',
        disabled: 'disabled',
    });
    const [values, setValues]  = React.useState([]);
    const allFieldsComplete = state.occasion && state.price && state.recipient ? '' : 'disabled';

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setState({
            ...state,
            [name]: value,
        });
        try {
            const selectedValues = values;
            const selectedSplitValue = value.split('&');
            const index = selectedValues.findIndex((check) => check === selectedSplitValue);
            if (index > -1) {
                selectedValues.splice(0, index);
            } else {
                selectedValues.push(...selectedSplitValue);
            }
            setValues(selectedValues);
        } catch (error) {
            return error;
        }
        return null;
    };

    const handleOnClick = () => {
        const querystring = `?facet=${state.recipient}&${state.occasion}&${state.price}`;
        const path = data.reference[0].landing_page?.href ? `${data.reference[0].landing_page.href}` : '/';
        history.push({
            pathname: path,
            search: querystring,
            state: values,
        });
    };
    const dataSelector = data?.reference[0];
    const recipients = dataSelector.facet_recipient?.recipient?.value;
    const occasions = dataSelector.facet_occasion?.occasion?.value;
    const prices = dataSelector.facet_price?.price?.value;

    // TODO: add alt (right flanking image) support
    const headingImage = dataSelector.heading_image[0] ? <img src={dataSelector.heading_image[0].url} alt={dataSelector.heading_image[0].title} /> : '';

    return ( // Render Vertical Menus
        <div className={classes.giftFinderGFB}>
            <div className={classes.container}>
                <div className={classes.heading}>
                    {headingImage ? <div className={classes.headingImg}>{headingImage}</div> : '' }
                    <h2 className={classes.headingCopy}>{dataSelector.heading}</h2>
                </div>
                <Grid container spacing={3}>
                    <Grid item md={4} xs={12} className={classes.fieldBlock}>
                        <FormControl variant="outlined">
                            <InputLabel htmlFor="recipient_select">Who&rsquo;s This For?</InputLabel>
                            <NativeSelect
                                defaultValue=""
                                className={classes.select}
                                value={state.recipient}
                                onChange={handleChange}
                                inputProps={{
                                    name: 'recipient',
                                    id: 'recipient_select',
                                }}
                            >
                                <option aria-label="None" value="" />
                                {
                                    recipients?.map((k) => <option value={k.value}>{k.key}</option>)
                                }
                            </NativeSelect>
                        </FormControl>
                    </Grid>
                    <Grid item md={4} xs={12} className={classes.fieldBlock}>
                        <FormControl variant="outlined">
                            <InputLabel htmlFor="occasion_select">What&rsquo;s the Occasion?</InputLabel>
                            <NativeSelect
                                defaultValue=""
                                className={classes.select}
                                value={state.occasion}
                                onChange={handleChange}
                                inputProps={{
                                    name: 'occasion',
                                    id: 'occasion_select',
                                }}
                            >
                                <option aria-label="None" value="" />
                                {
                                    occasions?.map((k) => <option value={k.value}>{k.key}</option>)
                                }
                            </NativeSelect>
                        </FormControl>
                    </Grid>
                    <Grid item md={4} xs={12} className={classes.fieldBlock}>
                        <FormControl variant="outlined">
                            <InputLabel htmlFor="price_select">What&rsquo;s Your Budget?</InputLabel>
                            <NativeSelect
                                defaultValue=""
                                className={classes.select}
                                value={state.price}
                                onChange={handleChange}
                                inputProps={{
                                    name: 'price',
                                    id: 'price_select',
                                }}
                            >
                                <option aria-label="None" value="" />
                                {
                                    prices?.map((k) => <option value={k.value}>{k.key}</option>)
                                }
                            </NativeSelect>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <Button onClick={handleOnClick} disabled={allFieldsComplete} className={classes.button} variant="contained" color="secondary">FIND IT<Caret className={classes.iconStyle}>content</Caret>
                        </Button>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
}

GraphqlFoodGiftFinder.propTypes = {
    data: shape({
        facet_occasion: shape({
            occasion: shape({
                value: array.isRequired,
            }),
        }),
        facet_price: shape({
            price: shape({
                value: array.isRequired,
            }),
        }),
        facet_recipient: shape({
            recipient: shape({
                value: array.isRequired,
            }),
        }),
        heading: string.isRequired,
        heading_image: array.isRequired,
        landing_page: shape({
            title: string.isRequired,
            href: string.isRequired,
        }),
    }).isRequired,
    history: object.isRequired,
    classes: object.isRequired,
};

export default withStyles(styles)(withRouter(GraphqlFoodGiftFinder));
